import {FormComponent} from "./FormComponent";
import React from "react";
import {RightAside} from "./Aside/RightAside";

export class DetailsWithList extends FormComponent {
    protected fetchUrl: string | null = null;

    private tableHeadInit: boolean = false;
    private requestInProgress: boolean = false;

    protected fetchItem(sort: any = '') {
        this.requestInProgress = true;

        this.setState({id: this.state?.item.id, item: this.state?.item, items: []});

        this.request.fetch(this.fetchUrl + (sort ? '?sort=' + sort : ''), null, {method: 'GET'})
            .then((data: { item: { [key: string]: string }, rights: string[] } | any) => {

                if (!(data.item || null)) {
                    this.setState({
                        code: this.request.getResponseStatus() || 400,
                        message: data.message || 'unknown-error'
                    });
                    return;
                }

                this.requestInProgress = false;
                this.setState({...data, ...{id: data.id, item: data.item, items: data.item.items}}, () => {
                    this.initTableHead((sort: any) => {
                        this.fetchItem(sort);
                    });
                });

            }).catch(error => {
            this.onError(error);
        });
    }

    protected onSuccess(data: any, event: React.FormEvent): any {
        if (data.message) {
            (
                (event.target as HTMLElement).querySelector('form .alert.alert-success') as HTMLElement
            ).innerHTML = this.dictionary.get[data.message];
        }
        (
            (event.target as HTMLElement).querySelector('form .alert.alert-success') as HTMLElement
        ).classList.remove('hide');
        RightAside.reload = true;
    }

    initTableHead(callback: any) {
        if (this.tableHeadInit) {
            return;
        }
        this.tableHeadInit = true;

        document.querySelectorAll('thead th.sortable').forEach(th => {
            th.addEventListener("click", (event) => {
                if (this.requestInProgress) {
                    return;
                }
                const target = event.target as HTMLElement;
                let icon = target.tagName === 'I' ? target : target.querySelector('.bi'), sortWay;

                if (icon === null) {
                    document.querySelectorAll('thead .bi').forEach(i => {
                        i.remove();
                    });
                    icon = document.createElement('i');
                    icon.classList.add('bi');
                    icon.classList.add('bi-sort-down');
                    target.append(icon);
                }

                if (icon.classList.contains('bi-sort-down')) {
                    icon.classList.add('bi-sort-down-alt');
                    icon.classList.remove('bi-sort-down');
                    sortWay = ':a';
                } else {
                    icon.classList.add('bi-sort-down');
                    icon.classList.remove('bi-sort-down-alt');
                    sortWay = ':d';
                }

                callback(target.getAttribute('data-sortKey') + sortWay);
            });
        });
    }
}